<script>
	import { Switch } from "../../../lib/ui";
	import { V3_ONLY_TABS } from "./tabs";

	// 빌더 좌측 섹션 네비게이션. 탭 로직은 chat(Chat 인스턴스)이 소유 — 여긴 표현만.
	export let chat;
	export let tabList = [];

	$: visibleTabs = tabList.filter((t) => !V3_ONLY_TABS.includes(t.value) || chat.chatVersion === "V3");

	// lucide 스타일 아이콘(내부 마크업만; svg 래퍼는 공통)
	const icons = {
		info: '<circle cx="12" cy="7" r="4"/><path d="M5.5 21a6.5 6.5 0 0 1 13 0"/>',
		detail:
			'<path d="M14 3v4a1 1 0 0 0 1 1h4"/><path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z"/><path d="M9 13h6M9 17h6"/>',
		scene:
			'<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="9" cy="9" r="1.6"/><path d="m21 15-3.6-3.6a2 2 0 0 0-2.8 0L6 21"/>',
		// 대화 설정 — 조절 슬라이더(sliders-horizontal)
		conversation:
			'<path d="M21 4h-7M10 4H3M21 12h-9M8 12H3M21 20h-5M12 20H3"/><path d="M14 2v4M8 10v4M16 18v4"/>',
		block:
			'<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>',
		publish: '<path d="m22 2-7 20-4-9-9-4Z"/><path d="M22 2 11 13"/>',
		// 응답(폼 제출 수집) — 수신함(inbox)
		submissions:
			'<path d="M22 12h-6l-2 3h-4l-2-3H2"/><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>',
	};
</script>

<!-- 폰(<md=768px)은 상단 가로 탭(BuilderTopTabs)으로 대체 → 여기선 숨김.
     태블릿(md~lg)은 아이콘 레일(56px), 데스크톱(≥lg=1024px)은 풀 사이드바(220px). -->
<aside class="tw-hidden tw-w-14 tw-shrink-0 tw-flex-col tw-border-r tw-border-border tw-bg-sidebar tw-font-sans md:tw-flex lg:tw-w-[220px]">
	<!-- 브랜드/타이틀(AI챗 · 캐릭터 빌더)은 상단 탑바에 표시 → 중복 방지 위해 여기선 생략 -->
	<!-- 단계 nav -->
	<nav class="tw-flex tw-flex-1 tw-flex-col tw-gap-1 tw-px-2 tw-pt-4 lg:tw-px-3">
		<div class="tw-hidden tw-px-2 tw-pb-1 tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wide tw-text-muted-foreground lg:tw-block">
			빌더 단계
		</div>
		{#each visibleTabs as tab (tab.value)}
			<button
				type="button"
				title={tab.label}
				class="tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-gap-2.5 tw-rounded-lg tw-px-2.5 tw-py-2 tw-text-left tw-text-sm tw-transition-colors lg:tw-justify-start {chat.isCurrentTab(
					tab.value,
				)
					? 'tw-bg-primary/10 tw-font-semibold tw-text-primary'
					: 'tw-text-foreground/70 hover:tw-bg-muted hover:tw-text-foreground'}"
				on:click={() => chat.changeCurrentTab(tab.value)}
			>
				<svg
					class="tw-h-[18px] tw-w-[18px] tw-shrink-0"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				>
					{@html icons[tab.value] || ""}
				</svg>
				<span class="tw-hidden tw-flex-1 lg:tw-block">{tab.label}</span>
				{#if tab.required}
					<span class="tw-hidden tw-text-xs tw-text-destructive lg:tw-inline">*</span>
				{/if}
			</button>
		{/each}
	</nav>

	<!-- 블록 모드(V3): 레일에선 스위치만(라벨 툴팁) -->
	{#if chat.useBlock === "Y"}
		<div
			class="tw-m-2 tw-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-lg tw-bg-muted tw-px-2 tw-py-2.5 lg:tw-m-3 lg:tw-justify-between lg:tw-px-3"
			title="블록 모드(V3)"
		>
			<span class="tw-hidden tw-text-[13px] tw-font-medium tw-text-foreground lg:tw-inline">블록 모드(V3)</span>
			<Switch
				checked={chat.chatVersion === "V3"}
				on:click={() => chat.toggleBlockMode(chat.chatVersion !== "V3")}
			/>
		</div>
	{/if}
</aside>
